import axios from "axios";
import storage from "@/lib/storage";
import { isNative, PUBLIC_WEB_URL } from "@/lib/appConfig";
import { currentLang } from "@/i18n/languages";

const ENV_BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
// Native apps are served from localhost and have NO same-origin backend, so an empty
// base URL (env var not baked into the build) sends requests to the local WebView and
// they fail with no response ("No pudimos conectar con el servidor"). Always target the
// public backend on native; on web keep the build-time value (same-origin / proxy).
const BACKEND_URL = ENV_BACKEND || (isNative() ? PUBLIC_WEB_URL : "");
if (BACKEND_URL && !BACKEND_URL.startsWith("https://") && process.env.NODE_ENV === "production") {
    console.error("[Security] Backend URL must use HTTPS in production:", BACKEND_URL);
}
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: BACKEND_URL,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = storage.getItem("qc_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    config.headers["Accept-Language"] = currentLang();
    return config;
});

// Endpoints where a 401 should NOT trigger a forced logout (login attempts, etc.)
const SOFT_401_PATHS = ["/api/auth/login"];

api.interceptors.response.use(
    (r) => r,
    (err) => {
        const status = err?.response?.status;
        const url = err?.config?.url || "";
        const isSoft = SOFT_401_PATHS.some((p) => url.includes(p));
        if (status === 401 && !isSoft) {
            // Token expired / invalid → kick to login while preserving intended target
            const hadToken = !!storage.getItem("qc_token");
            if (hadToken) {
                storage.removeItem("qc_token");
                // Broadcast to other tabs
                try { window.dispatchEvent(new Event("qc_session_expired")); } catch (_e) {}
                const from = window.location.pathname + window.location.search;
                // Avoid loop if already at /login
                if (!window.location.pathname.startsWith("/login")) {
                    const ret = encodeURIComponent(from);
                    window.location.replace(`/login?expired=1&from=${ret}`);
                }
            }
        }
        return Promise.reject(err);
    },
);

export default api;
